import * as React from 'react'
import { Outlet } from 'react-router-dom-v5-compat'

import { useSplitEnabled } from '@buffer-mono/features'

import { usePageTitle } from '~publish/hooks/usePageTitle'
import { BufferLoading } from '~publish/legacy/shared-components'

import { DefaultPath } from '../AppPages/DefaultPath'

export const CommentsRouteHandler = (): JSX.Element => {
  const { isEnabled: isCommentsPageEnabled } = useSplitEnabled('geid-comments')
  const [flagStabilized, setFlagStabilized] = React.useState(false)
  const initialRender = React.useRef(true)

  // Set page title for all comments routes
  usePageTitle('Community')

  React.useEffect(() => {
    // After the initial render, mark the flag as stabilized
    // This prevents redirects after initial render
    if (initialRender.current) {
      initialRender.current = false

      // Small delay to allow for potential quick updates to the flag
      const timeoutId = setTimeout(() => {
        setFlagStabilized(true)
      }, 800)

      return () => clearTimeout(timeoutId)
    }
  }, [])

  // If we're on the initial load and the flag isn't ready, show the UI anyway
  // This prevents the blank screen while waiting for the flag
  if (!flagStabilized) {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100%',
        }}
      >
        <BufferLoading />
      </div>
    )
  }

  // Once the flag is stabilized, we can make the real routing decision
  // Uses Outlet, since routing is handled in AppPages
  if (isCommentsPageEnabled) {
    return <Outlet />
  }

  return <DefaultPath />
}
